module.exports = __webpack_public_path__ + "img/sld_isolator_ng_t1_b1_dark.1f7358fa.svg";